<template>
  <div>
    <!-- مودال -->
    <custom-popup
      v-model="dialog"
      max-width="500px"
      :cons="editCons"
      :loading.sync="loading"
      persistent
      @action="handleEditAction"
    >
      <v-card class="pa-4 rounded-lg" flat outlined>
        <v-row class="mt-4" no-gutters>
          <v-col cols="12" md="12" class="pa-2">
            <v-text-field
              v-model="tempItem.title"
              class="rounded-lg v-input--dense"
              outlined
              dense
              label="عنوان"
              validate-on-blur
              :rules="[rules.max]"
              clearable
              clear-icon="mdi-close-circle-outline"
              hint="لطفا یک نام برای لینک کوتاه خود اضافه کنید."
            />
          </v-col>
          <!-- <v-col cols="12" md="6">
              <custom-date-picker
                v-model="selectedDate"
                :format="'YYYY-MM-DD HH:mm:ss'"
                :type="'datetime'"
                input-class="form-control"
                wrapper-class="vpd-main"
              >
                <template #default="{ inputClass }">
                  <div class="vpd-input-group">
                    <label
                      for="custom-date-picker"
                      class="vpd-icon-btn"
                      style="background-color: rgb(65, 125, 244)"
                    >
                      <svg
                        width="16px"
                        height="16px"
                        fill="#f9f9f9"
                        viewBox="0 0 448 512"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="... (your path data) ..."></path>
                      </svg>
                      <span>تاریخ انقضا</span>
                    </label>
                    <input
                      id="custom-date-picker"
                      :class="[inputClass]"
                      type="text"
                      placeholder="انتخاب تاریخ"
                    />
                  </div>
                </template>
              </custom-date-picker>
            </v-col> -->
        </v-row>
        <v-row class="mt-4" no-gutters>
          <v-col cols="12" class="pa-2">
            <v-text-field
              v-model="tempItem.longUrl"
              class="rounded-lg v-input--dense"
              outlined
              dense
              label="لینک"
              validate-on-blur
              :rules="[rules.required, rules.urlFormat]"
              clearable
              clear-icon="mdi-close-circle-outline"
              hint="لطفا لینک مورد نظر خود را وارد کنید."
              placeholder="مانند http://www.google.com"
            />
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <v-btn
            @click="Edit"
            outlined
            :disabled="!checkRules"
            color="success"
            :loading="loading"
          >
            ویرایش
            <v-icon class="ms-1">mdi-pencil</v-icon>
          </v-btn>
          <v-btn @click="dialog = false" outlined color="error">لغو</v-btn>
        </v-card-actions>
      </v-card>
    </custom-popup>

    <!-- پیام اعلان -->
    <v-snackbar v-model="snackbar" :timeout="3000" :color="snackbarColor" top>
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/style.shortlink.css";
import { EditLink, GetLinks } from "./axios_shortlink.js";
import { checkUrl, isValidUrl } from "@/assets/js/FunctionLink.js";
import CustomDatePicker from "../../../core/plugins/TitleRibbon/pages/pickers/custom-date-picker.vue";
import CustomPopup from "../../../core/plugins/TitleRibbon/plugins/popup/customPopup.vue";

export default {
  name: "EditShortlink",
  // props: ["id", "dialog", "value"],
  props: {
    value: Boolean,
    item: Object,
  },
  components: { CustomDatePicker, CustomPopup },
  data() {
    return {
      editCons: {
        title: "ویرایش",
        icon: "mdi-pencil",

        buttons: [
          {
            type: "submit",
            handler: this.Edit,
            disabled: () => !this.checkRules,
          },
          {
            type: "close",
            handler: () => {
              this.dialog = false;
            },
          },
        ],
      },
      tempItem: {},
      selectedDate: new Date(),
      snackbar: false,
      snackbarText: "",
      snackbarColor: "success",
      loading: false,
      id_user: 1,
      snackbar: false,
      snackbarText: "",
      snackbarColor: "success",
      shortUrl: "",
      TitleUrl: "",
      longUrl: "",
      ended_at: "",
      infolink: {},
      isvalid: false,
      ShortLinks: [],
      rules: {
        required: (value) => !!value?.trim() || "لطفا لینک را وارد کنید",
        urlFormat: (value) => {
          const pattern = new RegExp(
            "^(https?:\\/\\/|ftp:\\/\\/|www\\.)?" + // پروتکل‌های مختلف یا www
              "(localhost|(([a-zA-Z\\d]([a-zA-Z\\d-]*[a-zA-Z\\d])*)\\.)+[a-zA-Z]{2,}|" + // localhost یا دامین
              "(\\d{1,3}(\\.\\d{1,3}){3}))" + // آی‌پی‌ها
              "(\\:\\d+)?" + // پورت (اختیاری)
              "(\\/[-a-zA-Z\\d%_.~+]*)*" + // مسیر
              "(\\?[;&a-zA-Z\\d%_.~+=-]*)?" + // کوئری پارامتر
              "(\\#(\\/[-a-zA-Z\\d%_.~+]*)?)?$", // هشتگ با مسیر اختیاری
            "i"
          );

          return (
            (!!value?.trim() && pattern.test(value)) ||
            "لطفا آدرس اینترنتی معتبر وارد کنید"
          );
        },
        max: (value) =>
          !!value && value.length <= 50
            ? true
            : "عنوان بیشتر از 50 حرف نباشد! لطفا عنوان کوتاه‌تری وارد کنید",
      },
    };
  },
  watch: {
    dialog(val) {
      if (val && this.item) {
        console.log(this.item, "item");
        this.tempItem = { ...this.item };
      }
      // if (!val) {
      //   this.initData();
      // }
    },
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    checkRules() {
      return (
        typeof this.rules.urlFormat(this.tempItem.longUrl) === "boolean" &&
        typeof this.rules.required(this.tempItem.longUrl) === "boolean" &&
        (this.tempItem.title === "" ||
          typeof this.rules.max(this.tempItem.title) === "boolean")
      );
    },
  },
  created() {
    // this.initData();
  },
  methods: {
    // initData() {
    //   GetLinks()
    //     .then((data) => {
    //       console.log("data: ", data);

    //       if (Array.isArray(data)) {
    //         this.ShortLinks = data;
    //       } else {
    //         console.log("داده‌های دریافت‌شده آرایه نیستند:", data);
    //       }
    //     })
    //     .catch((error) => {
    //       console.error("خطا در دریافت داده:", error);
    //     });
    // },
    handleEditAction(type) {
      if (type === "submit") {
        this.Edit();
      } else if (type === "close") {
        this.dialog = false;
      }
    },
    isExist(url) {
      if (!url) return false;
      url = url.trim().replace(/\/+$/, "").toLowerCase();
      return this.ShortLinks.some((p) => p.longUrl === url);
    },
    Back() {
      this.tempItem.longUrl = "";
      this.shortUrl = "";
    },
    showSnackbar(message, color) {
      this.snackbar = false;
      this.$nextTick(() => {
        this.snackbarText = message;
        this.snackbarColor = color;
        this.snackbar = true;
      });
    },
    Edit() {
      this.loading = true;

      if (!this.tempItem.longUrl) {
        this.showSnackbar("لطفاً یک آدرس وارد کنید.", "error");
        this.loading = false;
        return;
      }
      if (!isValidUrl(this.tempItem.longUrl)) {
        this.showSnackbar("لطفاً یک آدرس معتبر وارد کنید.", "error");
        this.loading = false;
        return;
      }
      this.tempItem.longUrl = checkUrl(this.tempItem.longUrl);
      const response = EditLink(this.tempItem.id, {
        link: this.tempItem.longUrl,
        title: this.tempItem.title.trim() || "",
        // ended_at: this.ended_at,
        updated_at: new Date().toISOString().split(".")[0],
      })
        .then((response) => {
          this.$emit("updateList");
          setTimeout(() => {
            this.loading = false;
            this.snackbarText = "لینک با موفقیت ویرایش شد!";
            this.snackbarColor = "success";
            this.snackbar = true;
            this.dialog = false;
          }, 2000);
          //this.$router.push("/shortlink");
        })
        .catch((error) => {
          this.loading = false;
          console.error("خطا در به‌روزرسانی لینک:", error);
          this.showSnackbar("مشکلی در ویرایش پیش آمد.", "error");
        });
    },
  },
};
</script>

<style scoped>
@media (max-width: 780px) {
  ::v-deep(.v-btn) {
    margin-top: 10px !important;
    padding-top: 10px !important;
  }
  ::v-deep(.v-text-field) {
    width: 100% !important;
    flex: 1 1 100%;
    margin-bottom: 10px !important;
  }
}
</style>
